import React from "react";
import { Tooltip as AntTooltip } from "antd";

import IconInfo from "~/components/Icons/info";

import s from "./InfoTooltip.less";

interface InfoTooltipProps {
  content?: string;
  title?: React.ReactNode;
  children?: React.ReactNode;
  placement?:
    | "top"
    | "topLeft"
    | "topRight"
    | "bottom"
    | "bottomLeft"
    | "bottomRight"
    | "left"
    | "right";
  minWidth?: number;
  maxWidth?: number;
  maxHeight?: number;
}

export const InfoTooltip: React.FC<InfoTooltipProps> = ({
  content,
  title,
  children,
  placement = "top",
  minWidth = 200,
  maxWidth = 500,
  maxHeight = 400,
}) => {
  const hasTitle = title !== undefined && title !== null && title !== "";
  const hasContent = Boolean(content?.trim());
  const hasTooltipContent = hasTitle || hasContent;
  const trigger = children ?? (
    <span
      style={{
        marginLeft: "5px",
        cursor: "pointer",
        display: "inline-flex",
      }}
    >
      <IconInfo width="16" height="16" fill="#495964" />
    </span>
  );

  if (!hasTooltipContent) {
    return <>{children ?? null}</>;
  }

  const tooltipTitle = title ?? (
    <div
      className={s.infoTooltipContent}
      style={{ maxHeight, overflowY: "auto", color: "#54616C" }}
      dangerouslySetInnerHTML={{ __html: content ?? "" }}
    />
  );

  return (
    <AntTooltip
      title={tooltipTitle}
      placement={placement}
      color="#fff"
      classNames={{ root: s.infoTooltipRoot, body: s.infoTooltipBody }}
      styles={{
        root: {
          minWidth,
          maxWidth,
        },
        body: {
          backgroundColor: "#fff",
          color: "#54616C",
          borderRadius: 4,
        },
      }}
    >
      {trigger}
    </AntTooltip>
  );
};
